// TODO: Probably need to handle more cases here, like `es` or `fish`
const pluralize = (str: string, n: number) => (
  n == 1 ? str : str + 's'
)

export default pluralize
